import { makeAutoObservable } from 'mobx';
import { validateTimeOfDay } from './validateTimeOfDay';

export class TimeOfDayData {
  startHour = 9;
  startMinute = 30;
  endHour = 4;
  endMinute = 0;

  constructor(initialData) {
    makeAutoObservable(this);
    if (initialData) {
      Object.keys(initialData).forEach(
        (field) => (this[field] = initialData[field])
      );
    }
  }

  //common methods
  resetToDefaults = () => {
    this.startHour = 9;
    this.startMinute = 30;
    this.endHour = 4;
    this.endMinute = 0;
  };

  updateTactic = (dataObj) => {
    for (const key in dataObj) {
      this[key] = dataObj[key];
    }
  };
  validate = () => {
    const data = {
      startHour: this.startHour,
      startMinute: this.startMinute,
      endHour: this.endHour,
      endMinute: this.endMinute,
    };

    const result = validateTimeOfDay(data);
    return result;
  };
  returnJson = () => {
    return {
      startHour: this.startHour,
      startMinute: this.startMinute,
      endHour: this.endHour,
      endMinute: this.endMinute,
    };
  };

  //specific methods
  setStartHour = (number) => {
    this.startHour = Number(number);
  };
  setStartMinute = (number) => {
    this.startMinute = Number(number);
  };
  setEndHour = (number) => {
    this.endHour = Number(number);
  };
  setEndMinute = (number) => {
    this.endMinute = Number(number);
  };
}
